export function getImageBase64Url({ instance, dimensions, zoom, multiplier }) {
  return instance.toDataURL({
    format: 'png',
    width: dimensions.width * zoom,
    height: dimensions.height * zoom,
    left: (instance.getWidth() - dimensions.width * zoom) / 2,
    top: (instance.getHeight() - dimensions.height * zoom) / 2,
    multiplier,
  });
}

export function getImageDimensionsFromBase64(content, type = 'image/png') {
  return new Promise((resolve, reject) => {
    let image = new Image();
    image.src = `data:${type};base64,${content}`;
    image.onload = () => {
      resolve({ width: image.width, height: image.height });
      image = null;
    };
    image.onerror = (error) => {
      reject(error);
      image = null;
    };
  });
}
